import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=3492a1e7&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3492a1e7"]])

export default __exports__